import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

type SuporteModal = {
  hospital: boolean,
  criarHospital: boolean,
  editarHospital: boolean,
  visualizarGrupo: boolean,
  grupoRepasse: boolean,
  addOrEditGrupoRepasse: boolean,
  motivosInclusao: boolean
}

type SetSuporteModal = {
  name: string,
  value: boolean,
}

interface NovoGrupoRepasse {
  calculaAluguel: boolean
  calculaImposto: boolean
  grupoRepasseId: string
  grupoRepasseNome: string
  hospitalId: string
  hospitalNome: string
  podeLiberarSemIntegrar: boolean
  tipoItem: number
  tipoRepasseCodigoHis: string
}

interface NovoHospital {
  id: string;
  grupoHospitalId: string;
  nome: string;
  cnpj: string;
  codigoHis: string;
  ultimaSituacaoFluxoNF: string;
  fazConciliacao: boolean;
  integracaoAtiva: boolean;
  geraAgrupamento: boolean;
  notificaCobrancaAoLiberar: boolean;
  appExibeProducao: boolean;
  appExibeProducaoProfissionalExecutante: boolean;
  appExibeConciliacao: boolean;
  appLiberaGestaoProducao: boolean;
  appExibeCalculadora: boolean;
  backOfficePodeAlterarPrestador: boolean;
  backOfficePodeExcluirRepasse: boolean;
  cargaRegraResponsavelRepasse: string;
  fazCargaRepasseArquivo: boolean;
  cargaRepasseArquivoModoAgrupamento: string;
  exibirOpcaoRelatorioAssinaturaDiretoria: boolean;
  integracaoApiKey: string;
  liberaUsuarioGestor: boolean;
  liberaUsuarioProfissionalExecutante: boolean;
  calculoAtivo: boolean;
  cargaRepasseVerificaDuplicidadePorNumero: boolean;
  backOfficePodeIncluirItemRepasse: boolean;
  backOfficePodeExcluirItemRepasse: boolean;
  calculoModoDisparo: string;
  grupoRepassePadraoHonorarioMedicoId: string;
  notaFiscalModoUpload: string;
  permiteNaoGestorEnviarNotaFiscal: boolean;
  naoSolicitarNFPrestadorPF: boolean;
  calcularPorContratoComRegra: boolean;
  podeProvisionarRepasse: boolean;
  regraRepassePadraoHisId: string;
  logo: string;
  cargaRepasseStatusInicial: string;
}

type Mode = 'CREATE' | ''

@Module({ namespaced: true, name: 'SuporteHospitaisRemuneracaoStore' })
export default class SuporteHospitaisRemuneracaoStore extends VuexModule {
  private novoHospitalDefault: NovoHospital = {
    id: '',
    grupoHospitalId: '',
    nome: '',
    cnpj: '',
    codigoHis: '',
    ultimaSituacaoFluxoNF: '',
    fazConciliacao: false,
    integracaoAtiva: false,
    geraAgrupamento: false,
    notificaCobrancaAoLiberar: false,
    appExibeProducao: false,
    appExibeProducaoProfissionalExecutante: false,
    appExibeConciliacao: false,
    appLiberaGestaoProducao: false,
    appExibeCalculadora: false,
    backOfficePodeAlterarPrestador: false,
    backOfficePodeExcluirRepasse: false,
    cargaRegraResponsavelRepasse: '',
    fazCargaRepasseArquivo: false,
    cargaRepasseArquivoModoAgrupamento: '',
    exibirOpcaoRelatorioAssinaturaDiretoria: false,
    integracaoApiKey: '',
    liberaUsuarioGestor: false,
    liberaUsuarioProfissionalExecutante: false,
    calculoAtivo: false,
    cargaRepasseVerificaDuplicidadePorNumero: false,
    backOfficePodeIncluirItemRepasse: false,
    backOfficePodeExcluirItemRepasse: false,
    calculoModoDisparo: '',
    grupoRepassePadraoHonorarioMedicoId: '',
    notaFiscalModoUpload: '',
    permiteNaoGestorEnviarNotaFiscal: false,
    naoSolicitarNFPrestadorPF: false,
    calcularPorContratoComRegra: false,
    podeProvisionarRepasse: false,
    regraRepassePadraoHisId: '',
    logo: '',
    cargaRepasseStatusInicial: '',
  }

  private novoGrupoRepasseDefault: NovoGrupoRepasse = {
    calculaAluguel: false,
    calculaImposto: false,
    grupoRepasseId: '',
    grupoRepasseNome: '',
    hospitalId: '',
    hospitalNome: '',
    podeLiberarSemIntegrar: false,
    tipoItem: 0,
    tipoRepasseCodigoHis: '',
  }

  public grupoHospital: any[] = []
  public hospitais: any[] = []
  public tipoEmpresasMedicas: any[] = []
  public grupoRepasses: any[] = []
  public modoUploadItems: any[] = []
  public tiposCarga: any[] = []
  public calculoModoDisparo: any[] = []
  public cargaRegraResponsavelRepasse: any[] = []
  public cargaRepasseArquivoModoAgrupamento: any[] = []
  public tiposCargaSelected: any[] = []
  public calculoModoDisparoSelected: string = ''
  public grupoHospitalDetails: any = {}
  public hospitalDetails: any = {}
  public itemGrupoRepasse: any = {}
  public grupoRepasse: any[] = []
  public motivosInclusao: any[] = []
  public showCadastroHospitais: boolean = false
  public hospitalId: string = ''
  public grupoRepasseId: string = ''
  public grupoHospitalId: string = ''
  public mode: Mode = ''
  public novoHospital: NovoHospital = { ...this.novoHospitalDefault }
  public novoGrupoRepasse: NovoGrupoRepasse = { ...this.novoGrupoRepasseDefault }
  public cnpjInput: string = ''
  public nomeInput: string = ''
  public cepInput: string = ''
  public bairroInput: string = ''
  public cidadeInput: string = ''
  public numeroInput: string = ''
  public logradouroInput: string = ''
  public complementoInput: string = ''
  public ufInput: string = ''
  public tipoEndereco: string = ''
  public motivoInclusao: string = ''

  public modal: SuporteModal = {
    hospital: false,
    criarHospital: false,
    editarHospital: false,
    visualizarGrupo: false,
    grupoRepasse: false,
    addOrEditGrupoRepasse: false,
    motivosInclusao: false
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setCnpjInput(cnpj: string) {
    this.cnpjInput = cnpj
  }

  @Mutation
  setNomeInput(nome: string) {
    this.nomeInput = nome
  }

  @Mutation
  setCepInput(cep: string) {
    this.cepInput = cep
  }

  @Mutation
  setBairroInput(bairro: string) {
    this.bairroInput = bairro
  }

  @Mutation
  setCidadeInput(cidade: string) {
    this.cidadeInput = cidade
  }

  @Mutation
  setNumeroInput(numero: string) {
    this.numeroInput = numero
  }

  @Mutation
  setLogradouroInput(logradouro: string) {
    this.logradouroInput = logradouro
  }

  @Mutation
  setComplementoInput(complemento: string) {
    this.complementoInput = complemento
  }

  @Mutation
  setUfInput(uf: string) {
    this.ufInput = uf
  }

  @Mutation
  setTipoEndereco(tipo: string) {
    this.tipoEndereco = tipo
  }

  @Mutation
  clearNovoHospital() {
    this.novoHospital = { ...this.novoHospitalDefault }
  }

  @Mutation
  clearVincularCnpj() {
    this.cnpjInput = ''
    this.nomeInput = ''
    this.cepInput = ''
    this.bairroInput = ''
    this.cidadeInput = ''
    this.numeroInput = ''
    this.logradouroInput = ''
    this.complementoInput = ''
    this.ufInput = ''
    this.tipoEndereco = ''
  }

  @Mutation
  clearNovoGrupoRepasse() {
    this.novoGrupoRepasse = { ...this.novoGrupoRepasseDefault }
  }

  @Mutation
  clearItemGrupoRepasse() {
    this.itemGrupoRepasse = {}
  }

  @Mutation
  setNovoHospital() {
    this.novoHospital = { ...this.hospitalDetails }
  }

  @Mutation
  setNovoGrupoRepasse() {
    this.novoGrupoRepasse = { ...this.itemGrupoRepasse }
  }

  @Mutation
  setGrupoRepasse(value: any[]) {
    this.grupoRepasse = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  setGrupoRepasseId(value: string) {
    this.grupoRepasseId = value
  }

  @Mutation
  setGrupoHospitalId(value: string) {
    this.grupoHospitalId = value
  }

  @Mutation
  setShowCadastroHospitais(value: boolean) {
    this.showCadastroHospitais = value
  }

  @Mutation
  setGrupoHospital(values: any[]) {
    this.grupoHospital = values
  }

  @Mutation
  setHospitais(values: any[]) {
    this.hospitais = values
  }

  @Mutation
  setTipoEmpresasMedicas(values: any[]) {
    this.tipoEmpresasMedicas = values
  }

  @Mutation
  setGrupoRepasses(values: any[]) {
    this.grupoRepasses = values
  }

  @Mutation
  setModoUploadItems(values: any[]) {
    this.modoUploadItems = values
  }

  @Mutation
  setGrupoHospitalDetails(values: any) {
    this.grupoHospitalDetails = values
    this.calculoModoDisparoSelected = values && values.calculoModoDisparo ? values.calculoModoDisparo.key : ''
  }

  @Mutation
  setHospitalDetails(values: any) {
    this.hospitalDetails = values
  }

  @Mutation
  setItemGrupoRepasse(values: any) {
    this.itemGrupoRepasse = values
  }

  @Mutation
  clearHospitalDetails() {
    this.hospitalDetails = {}
  }

  @Mutation
  setTiposCarga(values: any[]) {
    this.tiposCarga = values
  }

  @Mutation
  setCalculoModoDisparo(values: any[]) {
    this.calculoModoDisparo = values
  }

  @Mutation
  setCargaRegraResponsavelRepasse(values: any[]) {
    this.cargaRegraResponsavelRepasse = values
  }

  @Mutation
  setCargaRepasseArquivoModoAgrupamento(values: any[]) {
    this.cargaRepasseArquivoModoAgrupamento = values
  }

  @Mutation
  setTiposCargaSelected(values: any[]) {
    this.tiposCargaSelected = values
  }

  @Mutation
  setCalculoModoDisparoSelected(value: string) {
    this.calculoModoDisparoSelected = value
  }

  @Mutation
  setListaDeHospitais(values: any[]) {
    this.hospitais = values
  }

  @Mutation
  clearHospitaisDetails() {
    this.tiposCargaSelected = []
    this.calculoModoDisparoSelected = ''
    this.grupoHospitalDetails = {}
  }

  @Mutation
  setIdPessoaJuridica(id: string) {
    this.hospitalDetails.id = id
  }

  @Mutation
  setMotivosInclusao(values: any[]) {
    this.motivosInclusao = values
  }

  @Mutation
  setMotivoInclusao(value: string){
    this.motivoInclusao = value
  }

  @Action
  async getGrupoHospital() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllGrupoHospital()
    if (response.success) {
      this.context.commit('setGrupoHospital', response.data.itens)
    }
    return response
  }

  @Action
  async getHospitaisPorGrupo(id: string) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHospitaisPorGrupo(id)
    if (response.success) {
      this.context.commit('setHospitalId', id)
      this.context.commit('setHospitais', response.data)
    }
    return response
  }

  @Action
  async getTipoEmpresasMedicas() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getTipoEmpresasMedicas()
    if (response.success) {
      this.context.commit('setTipoEmpresasMedicas', response.data)
    }
    return response
  }

  @Action
  async getGrupoRepasses() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllGrupoRepasses()
    if (response.success) {
      this.context.commit('setGrupoRepasses', response.data)
    }
    return response
  }

  @Action
  async getModoUploadItems() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getModoUploadItems()
    if (response.success) {
      this.context.commit('setModoUploadItems', response.data)
    }
    return response
  }

  @Action
  async getTiposDeCarga() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllTipoCarga()
    if (response.success) {
      this.context.commit('setTiposCarga', response.data)
    }
    return response
  }

  @Action
  async getCalculoModoDisparo() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllTipoDisparo()
    if (response.success) {
      this.context.commit('setCalculoModoDisparo', response.data)
    }
    return response
  }

  @Action
  async getCargaRegraResponsavelRepasse() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllCargaRegraResponsavelRepasse()
    if (response.success) {
      this.context.commit('setCargaRegraResponsavelRepasse', response.data)
    }
    return response
  }

  @Action
  async getCargaRepasseArquivoModoAgrupamento() {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllCargaRepasseArquivoModoAgrupamento()
    if (response.success) {
      this.context.commit('setCargaRepasseArquivoModoAgrupamento', response.data)
    }
    return response
  }

  @Action
  async getGrupoHospitalById(id: string) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getAllGrupoHospitalById(id)
    if (response.success) this.context.commit('setGrupoHospitalDetails', response.data)
    return response
  }

  @Action
  async getHospitalById(id: string) {
    const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getHospitalById(id)
    if (response.success) this.context.commit('setHospitalDetails', response.data)
    return response
  }

  @Action
  async getGrupoRepasse() {
    try {
      const params = {
        grupoHospitalId: this.grupoHospitalId,
        hospitalId: this.hospitalId,
      }
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getGrupoRepasse(params)
      if (response.success) this.context.commit('setGrupoRepasse', response.data.itens)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  deleteGrupoRepasse() {
    try {
      const params = {
        grupoRepasseId: this.grupoRepasseId,
        hospitalId: this.hospitalId,
      }
      return Apis.RemuneracaoMedica.RemuneracaoMedicaApi.deleteGrupoRepasse(params)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async addOrUpdateGrupoRepasse() {
    try {
      const params = {
        ...this.novoGrupoRepasse,
        grupoHospitalId: this.grupoHospitalId,
        hospitalId: this.hospitalId,
      }
      return Apis.RemuneracaoMedica.RemuneracaoMedicaApi.addgrupoRepasse(params)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getListaDeHospitais() {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllHospital()
      if (request.success) this.context.commit('setListaDeHospitais', request.data.map((hospital: any) => ({ id: hospital.id, nome: hospital.nome })))
      return request
    } catch (error) {
      this.context.commit('setListaDeHospitais', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async updateGrupoHospital() {
    const dataToUpdate = { ...this.grupoHospitalDetails }

    delete dataToUpdate.createdOn
    delete dataToUpdate.transacaoFinanceiraId
    delete dataToUpdate.transacaoFinanceiraNome
    dataToUpdate.calculoAtivo = !!dataToUpdate.calculoAtivo
    dataToUpdate.cargaRepasseCriarGeracaoRepasse = !!dataToUpdate.cargaRepasseCriarGeracaoRepasse
    dataToUpdate.cargaRepasseTransacaoUnica = !!dataToUpdate.cargaRepasseTransacaoUnica
    dataToUpdate.cargaNaoCarregarPrestadorComCalculo = !!dataToUpdate.cargaNaoCarregarPrestadorComCalculo
    dataToUpdate.integracaoRepasseEnviarAlugueis = !!dataToUpdate.integracaoRepasseEnviarAlugueis
    dataToUpdate.id = dataToUpdate.id

    if (!this.tiposCargaSelected || this.tiposCargaSelected.length === 0) {
      dataToUpdate.tiposDeCarga = this.grupoHospitalDetails.tiposDeCarga.map(carga => carga.key)
    } else {
      dataToUpdate.tiposDeCarga = this.tiposCargaSelected
    }

    if (!this.calculoModoDisparoSelected) {
      delete dataToUpdate.calculoModoDisparo
    } else {
      dataToUpdate.calculoModoDisparo = this.calculoModoDisparoSelected
    }

    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateGrupoHospital(dataToUpdate)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async createGrupoHospital() {
    const dataToCreate = { ...this.grupoHospitalDetails }

    dataToCreate.tiposDeCarga = this.tiposCargaSelected
    dataToCreate.calculoModoDisparo ? dataToCreate.calculoModoDisparo = this.calculoModoDisparoSelected : delete dataToCreate.calculoModoDisparo
    dataToCreate.calculoAtivo = !!dataToCreate.calculoAtivo
    dataToCreate.possuiCalculoGestor = !!dataToCreate.possuiCalculoGestor
    dataToCreate.logo = dataToCreate.logo || '0'
    dataToCreate.cargaRepasseCriarGeracaoRepasse = !!dataToCreate.cargaRepasseCriarGeracaoRepasse
    dataToCreate.cargaRepasseTransacaoUnica = !!dataToCreate.cargaRepasseTransacaoUnica
    dataToCreate.cargaNaoCarregarPrestadorComCalculo = !!dataToCreate.cargaNaoCarregarPrestadorComCalculo
    dataToCreate.integracaoRepasseEnviarAlugueis = !!dataToCreate.integracaoRepasseEnviarAlugueis

    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createGrupoHospital(dataToCreate)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async criarHospital() {
    try {
      const params: any = { ...this.novoHospital, ...this.hospitalDetails }
      params.grupoHospitalId = this.hospitalId
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.createHospital(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async atualizarHospital() {
    const MAXIMO_DOCUMENTOS_ADICIONAIS_DEFAULT = 10

    try {
      const params: any = { ...this.hospitalDetails }
      delete params.integracaoAluguelAgrupamento
      params.grupoHospitalId = this.hospitalId
      params.id = this.hospitalDetails.id

      if (params.habilitaDocumentoAdicional) {
        if (!params.maximoDocumentoAdicional) params.maximoDocumentoAdicional = MAXIMO_DOCUMENTOS_ADICIONAIS_DEFAULT
        if (!params.documentoAdicionalObrigatorio || !params.minimoDocumentoAdicional) params.minimoDocumentoAdicional = 0
      } else {
        params.maximoDocumentoAdicional = 0
      }

      // Função para verificar se o campo key esta presente no objeto
      const ajustarCamposComKey = (obj: any, campos: string[]) => {
        campos.forEach((campo) => {
          if (obj[campo] && typeof obj[campo] === 'object' && 'key' in obj[campo]) {
            obj[campo] = obj[campo].key
          } else if (!obj[campo]) {
            obj[campo] = null
          }
        })
      }

      // Campos que tem o key
      const camposParaVerificar = [
        'cargaRepasseStatusInicial',
        'grupoRepassePadraoHonorarioMedicoId',
        'calculoModoDisparo',
        'cargaRegraResponsavelRepasse',
        'notaFiscalModoUpload',
        'cargaRepasseArquivoModoAgrupamento',
        'ultimaSituacaoFluxoNF',
      ]

      ajustarCamposComKey(params, camposParaVerificar)

      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.updateHospital(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async verifyCnpj() {
    try {
      const response = await Apis.Cadastro.CadastroApi.checkCadastroEmpresaMedica(this.cnpjInput)
      if (response.success) {
        this.context.commit('setHospitalDetails', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async createPessoaJuridica() {
    try {
      const params: any = {
        nomeFantasia: this.nomeInput,
        razaoSocial: this.nomeInput,
        cnpj: this.cnpjInput,
        contatos: [],
        enderecos: [
          {
            cep: this.cepInput,
            bairro: this.bairroInput,
            cidade: this.cidadeInput,
            numero: this.numeroInput,
            logradouro: this.logradouroInput,
            complemento: this.complementoInput,
            tipo: this.tipoEndereco,
            uf: this.ufInput,
          }
        ],
      }
      const response = await Apis.Cadastro.CadastroApi.upsertEmpresaMedica(params)
      this.context.commit('setIdPessoaJuridica', response.data)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getMotivosInclusao(idGrupoHospital: string){
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.getMotivoInclusao(idGrupoHospital)
      this.context.commit('setMotivosInclusao', response.data)
    } catch(err){}
  }

  @Action
  async criarEditarMotivoInclusao(payload: { idGrupoHospital: any, idMotivo: string, mode: 'create' | 'edit' | any }){
     const { idGrupoHospital, idMotivo, mode } = payload;

     try {
      let payload = {
        motivo: this.motivoInclusao,
        IdGrupoHospital: idGrupoHospital,
      }

      if(mode === 'edit'){
        payload['id'] = idMotivo
      }

      const response = mode === 'create' ? await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.criarMotivoInclusao(payload) : await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.editarMotivoInclusao(payload)
      if (response.success) {
        await this.context.dispatch('getMotivosInclusao', idGrupoHospital)
        return response
      }

      return { success: false, message: response.message ? response.message : 'Ocorreu um erro na requisição.' }
    } catch(err){}
  }

  @Action
  async excluirMotivoInclusao(params: {id: string, idGrupoHospital: string}){
    try {
      const response = await Apis.RemuneracaoMedica.RemuneracaoMedicaApi.excluirMotivoInclusao(params.id)
      if (response.success) {
        await this.context.dispatch('getMotivosInclusao', params.idGrupoHospital)
        return response
      }

      return { success: false, message: response.message ? response.message : 'Ocorreu um erro na requisição.' }
    } catch(err){}
  }
}
